module.exports = __webpack_public_path__ + "static/img/Rgh-secure-communicatino-barrs.b9030a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/Rgh-secure-communicatino-barrs.png
// module id = ashW
// module chunks = 1